import { SITE_URL } from "./constants";
// 상품 상세 페이지의 SEO 메타데이터를 생성하는 순수 빌더.
// 프레임워크 비의존 → App Router 전환 시 generateMetadata에서 그대로 재사용한다.
export const buildProductSeo = (product)=>{
    var _product_tags;
    // 쿼리 파라미터가 붙어도 대표(정규) URL은 항상 이 형태로 고정한다.
    const canonical = "".concat(SITE_URL, "/products/").concat(product.id);
    // SEO 전용 메타 필드(metafields_*)가 있으면 우선 사용, 없으면 기본값으로 폴백.
    const baseTitle = product.metafields_global_title_tag || product.title;
    const title = "".concat(baseTitle, " - 쏠북");
    const description = product.metafields_global_description_tag || product.description || (((_product_tags = product.tags) === null || _product_tags === void 0 ? void 0 : _product_tags.length) ? product.tags.join(", ") : "");
    return {
        title,
        description,
        canonical,
        openGraph: {
            title,
            description,
            url: canonical,
            images: product.thumb_img ? [
                {
                    url: product.thumb_img,
                    alt: product.title
                }
            ] : undefined
        }
    };
};
